<td [attr.colspan]="columns?.length" class="flex w-full">
  <div class="flex justify-content-center w-full">
    <span class="font-semibold">{{ "No_records_found" | i18next }}</span>
  </div>
</td>
